/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { GET_RECORD_TASK_VIDEO, RECORD_TASK_VIDEO_RESPONSE, RESET_TASK_VIDEO } = constants.GetRecordTaskVideoConstants;

export default {
  GET_RECORD_TASK_VIDEO,
  RECORD_TASK_VIDEO_RESPONSE,
  RESET_TASK_VIDEO,

  requestFieldTaskCount: payload => ({
    type: GET_RECORD_TASK_VIDEO,
    payload
  }),
  fieldTaskCountReceived: () => ({
    type: RECORD_TASK_VIDEO_RESPONSE
  })
};
